export function isFirstLoad(sessionKey = "isSession"): boolean {
  if (typeof window === "undefined") return false;
  const sessionValue = sessionStorage.getItem(sessionKey);
  if (sessionValue === "true") return true;

  return false;
}
